export default "//yastatic.net/s3/distribution/pythia/frontend/_/2f3f90c35b929078a2baf51a7d751a4b.svg";